import React from 'react';
import { getAllHarmonies, rgbToHex } from '../../utils/colorUtils';
import AddIcon from '@mui/icons-material/Add';
import './ColorHarmonyPanel.css';

interface ColorHarmonyPanelProps {
  baseColor: string;
  onAddColor: (color: string) => void;
  onClose: () => void;
}

const ColorHarmonyPanel: React.FC<ColorHarmonyPanelProps> = ({
  baseColor,
  onAddColor,
  onClose,
}) => {
  const harmonies = getAllHarmonies(baseColor);

  return (
    <div className="harmony-panel">
      <div className="harmony-header">
        <span className="harmony-title">Color Harmonies</span>
        <button className="harmony-close" onClick={onClose}>
          &times;
        </button>
      </div>
      <div className="harmony-base">
        <div
          className="harmony-base-swatch"
          style={{ backgroundColor: baseColor }}
        />
        <span className="harmony-base-label">Base: {rgbToHex(baseColor)}</span>
      </div>
      <div className="harmony-list">
        {harmonies.map((harmony) => (
          <div key={harmony.name} className="harmony-group">
            <span className="harmony-group-name">{harmony.name}</span>
            <div className="harmony-colors">
              {harmony.colors.map((color, index) => (
                <button
                  key={index}
                  className="harmony-swatch"
                  style={{ backgroundColor: color }}
                  onClick={() => onAddColor(color)}
                  title={`Add ${rgbToHex(color)} to palette`}
                >
                  <AddIcon className="harmony-add-icon" />
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ColorHarmonyPanel;
